export interface NaturalFloatingSize {
  width: number
  height: number
}

export function getNaturalFloatingBoxSize(
  rect: {width: number, height: number},
  fallback: {
    scrollWidth: number
    scrollHeight: number
    offsetWidth: number
    offsetHeight: number
  },
): NaturalFloatingSize {
  return {
    width: Math.ceil(Math.max(rect.width, fallback.scrollWidth, fallback.offsetWidth, 0)),
    height: Math.ceil(Math.max(rect.height, fallback.scrollHeight, fallback.offsetHeight, 0)),
  }
}
